import RegisterForm from "@/components/auth/RegisterForm";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const Register = () => {
  return (
    <Card className="w-[90%] p-4">
      <CardHeader>
        <CardTitle className="text-2xl font-bold text-center mb-3">
          Register / Sign-Up
        </CardTitle>
      </CardHeader>
      <CardContent>
        <RegisterForm />
      </CardContent>
    </Card>
  );
};

export default Register;
